(function () {
  'use strict';

  /* @ngdoc object
   * @name userActivityReport
   * @description
   *
   */
  angular
    .module('userActivityReport', [
      'ui.router'
    ]);
}());
